import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Public landing for old family-to-family referral links (/refer/:code).
 *
 * The referral-rewards program has ended (blueprint ruling R4-G: no promo
 * credits, ever). This page stays mounted so shared links never 404 — it
 * explains the sunset honestly and points people at plain registration.
 * No preview/redeem API calls are made.
 */
export default function ReferRedeem() {
  const { user } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-10 dotted-bg"
      data-testid="refer-page"
    >
      <div className="brutal-card bg-white p-6 sm:p-8 max-w-xl w-full">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-12 h-12 rounded-2xl border-[3px] border-[color:var(--ink)] bg-[color:var(--coral)] text-white flex items-center justify-center">
            <Heart size={22} fill="currentColor" />
          </span>
          <div>
            <div className="display text-xs uppercase tracking-[0.25em] text-[color:var(--ink-soft)] font-bold">
              A SonSpeak family invited you
            </div>
            <h1 className="display text-2xl sm:text-3xl font-extrabold leading-tight">
              Referral rewards have ended
            </h1>
          </div>
        </div>

        <p className="mb-4 text-[color:var(--ink-soft)] leading-relaxed" data-testid="refer-sunset">
          SonSpeak no longer offers referral months. You can still create an
          account in early access — no payment today.
        </p>

        {user ? (
          <Link
            to="/profiles"
            className="pill-btn primary w-full justify-center text-base py-3"
            data-testid="refer-profiles"
          >
            Go to my boards <ArrowRight size={16} />
          </Link>
        ) : (
          <div className="grid sm:grid-cols-2 gap-2">
            <Link
              to="/register"
              className="pill-btn primary justify-center text-base py-3"
              data-testid="refer-register"
            >
              Create account <ArrowRight size={16} />
            </Link>
            <Link
              to="/login"
              className="pill-btn justify-center text-base py-3"
              data-testid="refer-login"
            >
              I already have an account
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
